import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import api from "../lib/api";
import { useAuth } from "../lib/AuthContext";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Mic } from "lucide-react";

export default function Login() {
  const navigate = useNavigate();
  const { loginWithToken } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      loginWithToken(data.token, data.user);
      toast.success(`Benvenuto ${data.user.name}`);
      navigate("/dashboard");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Errore di accesso");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#FBF9F5] grid lg:grid-cols-2">
      <div className="hidden lg:block relative">
        <img
          alt="Osteria"
          src="https://images.unsplash.com/photo-1574966739987-65e38db0f7ce?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTJ8MHwxfHNlYXJjaHwyfHxpdGFsaWFuJTIwcmVzdGF1cmFudCUyMGNoZWYlMjBkaW5pbmclMjB0YWJsZSUyMGFtYmlhbmNlfGVufDB8fHx8MTc4ODQ2OTg0MXww&ixlib=rb-4.1.0&q=85"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-[#161412]/80 via-transparent to-transparent"/>
        <div className="absolute bottom-10 left-10 right-10 text-white">
          <div className="font-serif-display text-5xl leading-tight">"La voce è<br/>più veloce della penna."</div>
          <div className="mt-3 text-white/80 text-sm">— Osteria del Sole, Firenze</div>
        </div>
      </div>

      <div className="flex items-center justify-center p-6 sm:p-12">
        <div className="w-full max-w-md">
          <Link to="/" className="flex items-center gap-2 mb-10">
            <div className="w-9 h-9 rounded-2xl bg-gradient-to-br from-[#D99B26] to-[#C85A32] grid place-items-center text-white font-black">V</div>
            <span className="font-heading text-lg font-black tracking-tight">VOICE<span className="bg-gradient-to-r from-[#D99B26] to-[#C85A32] text-transparent bg-clip-text">MENU</span></span>
          </Link>
          <h1 className="font-serif-display text-4xl font-bold">Bentornato</h1>
          <p className="text-[#6B625B] mt-2">Accedi per aggiornare il tuo menu con la voce.</p>

          <form onSubmit={submit} className="mt-8 space-y-4">
            <div>
              <Label htmlFor="email">Email</Label>
              <Input data-testid="login-email-input" id="email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="mario@osteria.it" />
            </div>
            <div>
              <Label htmlFor="password">Password</Label>
              <Input data-testid="login-password-input" id="password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} placeholder="••••••••" />
            </div>
            <Button data-testid="login-submit-btn" disabled={loading} className="w-full bg-[#C85A32] hover:bg-[#B24E2A] text-white rounded-full py-6">
              {loading ? "Accesso..." : "Accedi"}
            </Button>
          </form>

          <p className="mt-6 text-sm text-[#6B625B] text-center">
            Non hai un account? <Link to="/signup" data-testid="signup-link" className="text-[#C85A32] font-semibold hover:underline">Registrati</Link>
          </p>
        </div>
      </div>
    </div>
  );
}
